import { IUser } from '../users/Users';

export const USERS_LOAD_SUCCESS = 'USERS_LOAD_SUCCESS';
export interface ISetUsers {
  type: typeof USERS_LOAD_SUCCESS;
  users: IUser[];
}

export type TUsersActions = ISetUsers;
